export default "__VITE_ASSET__J9iIzbmS__"